import { Input, message, Switch } from 'antd'
import {
	canEnablePaymentProvider,
	PAYMENT_PROVIDER_SWITCH_KEYS,
} from './paymentProviderValidation'
import { PAYMENT_PROVIDER_CONFIG } from './paymentProviderConfig'

const FORM_SWITCH_KEYS = {
	click: PAYMENT_PROVIDER_SWITCH_KEYS.click,
	pay_me: PAYMENT_PROVIDER_SWITCH_KEYS.payme,
	apelsin: PAYMENT_PROVIDER_SWITCH_KEYS.uzum,
	anor: PAYMENT_PROVIDER_SWITCH_KEYS.anor,
	uzqr: PAYMENT_PROVIDER_SWITCH_KEYS.uzqr,
}

const ProviderInput = ({ field, value, onChange, disabled = false }) => {
	const InputComponent = field.secure ? Input.Password : Input

	return (
		<label className='payment-provider__field'>
			<span>{field.label}</span>
			<InputComponent
				className='create-device__control'
				placeholder={field.label}
				allowClear
				autoComplete='off'
				disabled={disabled}
				value={value || ''}
				onChange={e => onChange({ [field.key]: e.target.value })}
			/>
		</label>
	)
}

const PaymentProvidersComponent = ({
	data,
	onChange,
	t,
	disabled = false,
	canEditField = () => true,
}) => {
	const activationErrorKey =
		'pages.devices.addNewDeviceColumns.paymentProviderActivationError'

	const applyProviderFieldChanges = values => {
		const nextData = { ...data, ...values }
		const updates = { ...values }

		PAYMENT_PROVIDER_CONFIG.forEach(provider => {
			const validationKey = FORM_SWITCH_KEYS[provider.switchKey]
			if (
				nextData[provider.switchKey] &&
				!canEnablePaymentProvider(validationKey, nextData)
			) {
				updates[provider.switchKey] = false
			}
		})

		onChange(updates)
	}

	const handleSwitchChange = (provider, checked) => {
		const validationKey = FORM_SWITCH_KEYS[provider.switchKey]
		if (checked && !canEnablePaymentProvider(validationKey, data)) {
			message.warning(t(activationErrorKey))
			return
		}

		onChange({ [provider.switchKey]: checked })
	}

	return (
		<div className='payment-providers'>
			{PAYMENT_PROVIDER_CONFIG.map(provider => (
				<section className='payment-provider' key={provider.name}>
					<div className='payment-provider__header'>
						<div className='payment-provider__title'>
							<img
								src={provider.logo}
								alt={provider.name}
								className='payment-provider__logo'
							/>
							<h3>{provider.name}</h3>
						</div>
						<Switch
							checked={Boolean(data[provider.switchKey])}
							disabled={disabled || !canEditField(provider.switchKey)}
							onChange={checked =>
								handleSwitchChange(provider, checked)
							}
						/>
					</div>

					<div className='payment-provider__fields'>
						{provider.fields.map(field => (
							<ProviderInput
								key={field.key}
								field={field}
								value={data[field.key]}
								onChange={applyProviderFieldChanges}
								disabled={disabled || !canEditField(field.key)}
							/>
						))}
					</div>
				</section>
			))}
		</div>
	)
}

export default PaymentProvidersComponent
